import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

import { Title } from "../../components/NewTitle";
import { Link } from "react-router-dom";
// import QueueAnim from "rc-queue-anim";

export const HomeManagement = ({ noToggleBtn, tryNowBtn } = {}) => {
  const { t } = useTranslation();

  const cardContent = [
    {
      title: t("home.management.item-one.title"),
      description: t("home.management.item-one.subtitle"),
      cardImg:
        "//files.authing.co/authing-website/home-user-identity-manage-tiny.png",
      tags: [
        {
          tag: t("home.management.item-one.list-five"),
          tagLink: "/learn/guard",
        },

        { tag: t("home.management.item-one.list-two"), tagLink: "/verify" },
        { tag: t("home.management.item-one.list-three"), tagLink: "/mfa" },

        { tag: t("home.management.item-one.list-four"), tagLink: "/learn/sso" },
        {
          tag: t("home.management.item-one.list-one"),
          tagLink: "//docs.authing.cn/v2/guides/authentication/social/",
          type: "doc",
        },
        {
          tag: t("home.management.item-one.list-six"),
          tagLink: "//docs.authing.cn/v2/guides/pipeline/",
          type: "doc",
        },
      ],
    },
    {
      title: t("home.management.item-two.title"),
      description: t("home.management.item-two.subtitle"),
      cardImg:
        "//files.authing.co/authing-website/home-employee-identity-manage-tiny.png",

      tags: [
        { tag: t("home.management.item-two.list-one"), tagLink: "/learn/sso" },
        { tag: t("home.management.item-two.list-two"), tagLink: "/mfa" },
        {
          tag: t("home.management.item-two.list-three"),
          tagLink: "/solutions/private-cloud",
        },
        {
          tag: t("home.management.item-two.list-four"),
          tagLink: "//docs.authing.cn/v2/guides/access-control/",
          type: "doc",
        },
        { tag: t("home.management.item-two.list-five"), tagLink: "/verify" },
      ],
    },
  ];
  const HomeManagementCard = (props) => {
    const [showMore, setShowMore] = useState(noToggleBtn || false);
    const { title, description, tags, cardImg } = props;
    return (
      <div className="home-management-card">
        {/* <QueueAnim type="left" delay={300} duration={2000}> */}
        <div key="1" className="title">
          {title}
        </div>
        <div key="2" className="description">
          {description}
        </div>
        {/* </QueueAnim> */}
        {!noToggleBtn && (
          <div
            className="check-more-warp"
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            <span className="check-more">{t("common.check-fun")}</span>

            <span
              style={{
                display: "inline-block",
                marginLeft: "4px",
                transform: showMore ? "rotate(180deg)" : "rotate(90deg)",
                color: "#396aff",
                cursor: "pointer",
              }}
            >
              <i className="icon authing-icon authing-arrow-down-line arrow"></i>
            </span>
          </div>
        )}

        <div className="card-content">
          {!showMore && (
            <div className="card-content-img">
              <img src={cardImg} alt="authing employee-identity-manage" />
            </div>
          )}
          {showMore && (
            <div className="card-content-tags">
              {/* <QueueAnim type="bottom" delay={300} duration={2000}> */}
              {tags.map((item, index) => {
                return (
                  <div key={index}>
                    {item.type && item.type === "doc" ? (
                      <a
                        href={item.tagLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="card-content-tag"
                      >
                        {item.tag}
                      </a>
                    ) : (
                      <Link to={item.tagLink} className="card-content-tag">
                        {item.tag}
                      </Link>
                    )}
                  </div>
                );
              })}
              {/* </QueueAnim> */}
            </div>
          )}

          {tryNowBtn}
        </div>
      </div>
    );
  };
  return (
    <div className="home-management">
      <div className="inner">
        <Title title={t("home.management.title")} />
        <div className="home-management-card-warp">
          {cardContent.map((card) => (
            <HomeManagementCard
              title={card.title}
              description={card.description}
              tags={card.tags}
              cardImg={card.cardImg}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
